import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function TwoManDeliveryService() {
  const [quote, setQuote] = useState('');

  const handleQuoteChange = (event) => {
    setQuote(event.target.value);
  };

  const handleSubmitQuote = () => {
    alert(`Your free quote request has been submitted: ${quote}`);
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/twomendelivery.webp')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl font-semibold">Two-Man Delivery Service</h1>
          <p className="text-lg md:text-xl mt-4 max-w-3xl mx-auto">
            Moving bulky furniture made easy. Let us handle the hard part. Get your free quote!
          </p>
        </div>
      </div>

      {/* Service Overview Section */}
      <section id="service-overview" className="py-16 px-3 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Struggling with Large Furniture?</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 text-justify font-thin">
            Moving is hard enough as it is. Trying to move bulky furniture through narrow hallways and up stairs can make it seem impossible. Let 1UKLogistics take the stress out of your move with our expert two-man delivery service.
          </p>
        </div>

       
      </section>

      {/* Why Choose Us Section */}
      <section id="why-choose-us" className="px-3 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Why Choose 1UKLogistics?</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin text-justify">
            We specialize in delivering large and bulky furniture across the UK. With our two-man delivery teams, we can ensure a safe and efficient transportation of your items to your new home. We make moving easy, no matter how difficult it seems.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-12 xl:px-40">
          <div className="flex flex-col items-center bg-slate-900 text-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Expert Two-Man Teams</h3>
            <p className="text-lg mt-4 text-center font-thin">
              Our trained two-man teams specialize in transporting heavy and bulky items. We’re careful and efficient.
            </p>
          </div>
          <div className="flex flex-col items-center bg-slate-900 text-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Nationwide Service</h3>
            <p className="text-lg mt-4 text-center font-thin">
              We offer our two-man delivery service across the UK, ensuring you get your items wherever you need them.
            </p>
          </div>
          <div className="flex flex-col items-center bg-slate-900 text-white shadow-lg p-6 rounded-lg">
            <h3 className="text-xl font-thin">Same-Day Delivery</h3>
            <p className="text-lg mt-4 text-center font-thin">
              Once your quote is approved, we can have your items picked up and delivered on the same day, fast and efficiently.
            </p>
          </div>
        </div>
      </section>

      {/* Request a Free Quote */}
      <section id="quote" className="py-16 px-3 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Get Your Free Quote</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin">
            Moving large furniture can be expensive. We offer affordable rates for two-man delivery services. Fill out the details below and get a free quote today!
          </p>
          <div className='flex justify-center'>
      <Link to='/contactus'>
    <button className="mt-4 px-8 py-2 bg-slate-900 text-white  ">  ContactUs</button></Link>
    </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-16 px-3 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">FAQ`s</h2>
          <div className="space-y-6 mt-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl  font-thin">How does the two-man delivery service work?</h3>
              <p className="text-lg mt-2 font-thin">
                You provide us with the details of the items you need moved, and we’ll give you a free quote. Once approved, our expert two-man team will arrive to move your items efficiently.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin">Do you handle bulky items?</h3>
              <p className="text-lg mt-2 font-thin">
                Yes! We specialize in moving large items such as sofas, beds, and furniture. Our two-man teams are experienced in handling these types of deliveries.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin">Can I get a same-day delivery?</h3>
              <p className="text-lg mt-2 font-thin">
                Absolutely! We offer same-day delivery, as long as the quote is approved, and the items are ready for pickup.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TwoManDeliveryService;
